import React, { useState } from 'react'

export const NavigationStateContext = React.createContext(null)

export const useNavigationState = () => React.useContext(NavigationStateContext)

export const NavigationStateProvider = ({ children }) => {
	const [navigationState, setNavigationState] = useState([])

	return (
		<NavigationStateContext.Provider value={[navigationState, setNavigationState]}>
			{children}
		</NavigationStateContext.Provider>
	)
}
